import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { initSession, loadSession } from "../utils/sessionManager";
import QRCode from "react-qr-code";
import {
  establishSignalRConnection,
  closeSignalRConnection,
} from "../services/WebSocketService";
import "../styles/Home.css";
import { useSessionId } from "../App";

const Home = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [qrValue, setQrValue] = useState<string | null>(null);
  const sessionId = useSessionId();

  const handleGenerateQR = async () => {
    setLoading(true);
    try {
      const session = await initSession();
      if (!session.valid) return;
      const loadedSession = loadSession();
      if (
        loadedSession.chatNumber === "0" ||
        !loadedSession.myUserId ||
        !loadedSession.requestToken
      ) {
        alert("Something went wrong");
        return;
      }

      setQrValue(`https://idless.org/connect/${loadedSession.chatNumber}`);

      await establishSignalRConnection(
        loadedSession.chatNumber!,
        loadedSession.myUserId,
        loadedSession.requestToken,
        (msg) => console.log("Received message:", msg),
        async (payload) => {
          if (payload.fromId)
            sessionStorage.setItem("otherUserId", payload.fromId);
          if (payload.from)
            sessionStorage.setItem("otherUserName", payload.from);
          if (payload.publicKey)
            sessionStorage.setItem("otherUserPubKey", payload.publicKey);
          if (payload.chatId) sessionStorage.setItem("chatId", payload.chatId);

          await closeSignalRConnection();
          navigate(`/${loadedSession.chatNumber}`);
        }
      );
    } catch (err) {
      console.error(err);
      alert("Failed to generate QR code. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="home-container">
      <div className="home-card">
        <h1>Welcome to IDless!</h1>
        <p>Generate a QR code and share it to start chatting.</p>

        {qrValue ? (
          <div className="qr-container">
            <div className="qr-code">
              <QRCode value={qrValue} size={180} />
            </div>
            <p className="qr-text">{qrValue}</p>
          </div>
        ) : (
          <button
            onClick={handleGenerateQR}
            disabled={loading}
            className="generate-btn"
          >
            {loading ? "Generating..." : "Generate QR"}
          </button>
        )}
      </div>
    </div>
  );
};

export default Home;
